import { useState, useEffect } from "react";

const MOBILE_QUERY =
  "(max-width: 639px), (max-height: 500px) and (orientation: landscape)";
const LANDSCAPE_QUERY = "(max-height: 500px) and (orientation: landscape)";

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
}

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}

export function useIsLandscape(): boolean {
  return useMediaQuery(LANDSCAPE_QUERY);
}
